import React from "react";

export const Purchase = () => {
  return <div>Purchase</div>;
};
